// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"31727aac","86":"3d5c1ca4","453":"8701dc61","475":"23ae00e1","525":"7f8a0224","531":"5db5c87b","556":"21aa9231","589":"05f162a9","621":"4825ea83","632":"ddcb2c27","752":"b7f316e4","888":"5655cb64","913":"c391d847","993":"988609af"}[chunkId] + ".chunk.js";
};